import { BundleOption } from '@/types/product';

export const isConfigurableCharacteristic = (c: BundleOption['characteristics'][number]) =>
  c.title && c.view;

/**

We need all variation views because, even though product selection occurs
only in the first step (in the first configurable characteristic, that is),
it might be affected by all variation views in the sequence.

Eg:
c1 -> null (non-configurable)
c2 -> XYZ  (variation view material/dimensions)
c3 -> null
c4 -> JKL  (variation view image)

variationViews will be [material/dimensions, image]
*/
export const getVariationViews = (option: BundleOption) => {
  return option.characteristics
    .filter(isConfigurableCharacteristic)
    .map((c) => c.view);
}